(function(){
  var s = document.createElement('script');
  var h = document.querySelector('head') || document.body;
  s.src = 'https://acsbapp.com/apps/app/dist/js/app.js';
  s.defer = true;
  s.onload = function(){
    const value = acsbJS.init({
      statementLink : '',
      footerHtml : '',
      hideMobile : false,
      hideTrigger : true,
      disableBgProcess : false,
      language : 'en',
      position : 'left',
      leadColor : '#1c3321',
      triggerColor : '#1c3321',
      triggerRadius : '50%',
      triggerPositionX : 'right',
      triggerPositionY : 'bottom',
      triggerIcon : 'people',
      triggerSize : 'medium',
      triggerOffsetX : 20,
      triggerOffsetY : 20,
      mobile : {
        triggerSize : 'small',
        triggerPositionX : 'right',
        triggerPositionY : 'center',
        triggerOffsetX : 10,
        triggerOffsetY : 0,
        triggerRadius : '50%'
      }
    });
  };
  h.appendChild(s);
})();